import React from 'react'

export const StarRating = ({ rating }) => {
  return (
    <span className="text-primary">
      {"★".repeat(Math.round(1))}
    </span>
  )
}